import { Store } from "@bryntum/core-thin";
import {
  ColumnConfig,
  DateColumnConfig,
  WidgetColumnConfig
} from "@bryntum/grid-thin";
import { AuditService } from "@app/services/http/audit.service";
import { MatCheckboxChange } from "@angular/material/checkbox";
import moment from "moment";

export class BaseAuditViewer {
  includeSystem = false;
  includeService = true;

  auditColumns: (ColumnConfig | DateColumnConfig | WidgetColumnConfig)[] = [
    {
      field: "commitDate",
      text: "Date",
      format: "DD/MM/YYYY HH:mm:ss",
      type: "date",
      width: "160px"
    },

    {
      field: "snapshotType",
      text: "Type",
      width: "80px"
    },
    {
      field: "author",
      text: "Author",
      width: "200px"
    },
    {
      text: "Changed",
      field: "changed",
      type: "widget",
      flex: 1,
      autoHeight: true,
      widgets: [
        {
          type: "chipview",
          valueProperty: "items",
          itemsFocusable: false,
          navigator: null,
          closable: false,
          style: {
            flexFlow: "row wrap",
            display: "flex",
            padding: "5px 0 3px 0"
          }
        } as any
      ]
    }
  ];

  constructor(
    public auditService: AuditService,
    public auditType: string
  ) {}

  applyFilters(auditGrid: any) {
    let store: Store = auditGrid.gridEngine.store as Store;
    store.clearFilters();
    (store as any).filterBy((record) => {
      console.log("Filtering on author");
      return this.includeSystem || record.author !== "SYSTEM";
    });
  }

  updateIncludeSystem($event: MatCheckboxChange, auditGrid: any) {
    this.includeSystem = $event.checked;
    this.applyFilters(auditGrid);
  }

  queryAudit(entityId: number, auditType: string, auditGrid: any) {
    this.auditService.queryAudit(entityId, auditType, 0, 1000).then((value) => {
      console.log("Audit query result", value);

      auditGrid.addRow(
        value.map((value1) => {
          value1.commitDate = moment(value1.commitDate).toDate();
          // @ts-ignore
          value1.entityId = entityId;
          return value1;
        })
      );
      this.applyFilters(auditGrid);
    });
  }
}
